import { Component, OnInit } from '@angular/core';
import { Input, ViewChild, NgZone } from '@angular/core';
import { MapsAPILoader, AgmMap } from '@agm/core';
import { GoogleMapsAPIWrapper } from '@agm/core/services';
import { Constant } from '../Constant';
import { CustomStorage } from '../providers/Custom-storage.service';
import { MouseEvent as AGMMouseEvent } from '@agm/core';
import { parse } from 'path';
declare var google: any;
@Component({
  selector: 'mapstest',
  templateUrl: './mapstest.component.html',
  styleUrls: ['./mapstest.component.css']
})
export class MapstestComponent implements OnInit {
  circleRadius: number = 5000; // km
  geocoder: any;
  previous;
  lat: number;
  lng: number;
  address_level_1: string;
  address_level_2: string;
  address_country: string;
  address_zip: string;
  address_state: string;
  markers:any = [];
  supervisordetailsData: any = [];
  // public location:Location = {
  //   lat: 51.678418,
  //   lng: 7.809007,
  //   marker: {
  //     lat: 51.678418,
  //     lng: 7.809007,
  //     draggable: true
  //   },
  //   zoom: 5
  // };

  @ViewChild(AgmMap) map: AgmMap;
  constructor(public mapsApiLoader: MapsAPILoader, private localStorage: CustomStorage,
    private zone: NgZone,
    private wrapper: GoogleMapsAPIWrapper) {
    this.mapsApiLoader = mapsApiLoader;
    this.zone = zone;
    this.wrapper = wrapper;
    this.mapsApiLoader.load().then(() => {
      this.geocoder = new google.maps.Geocoder();
    });
  }

  ngOnInit() {
    this.markers.draggable = true;
    this.localStorage.getItem(Constant.KEY_SUPERVISORLOGIN).subscribe(result => {
      this.supervisordetailsData = result.response;
      for (let item of this.supervisordetailsData.sales_rep_locations.locations_data) {
        this.markers.push({
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
          label: item.sales_rep_id,
          draggable: true
         
        });
        //this.codeLatLng(this.markers);
      }
      this.getCoordinates(); 
     // this.findAddressByCoordinates();
       this.updateOnMap();
    });
  }
  getCoordinates() {
    // this.markers.setMap(null);
     if (this.markers.length > 0) {
       this.lat= this.markers[0].lat;      
       this.lng= this.markers[0].lng;
       
 }
   }
  
  //  getAddress(address) {
  //   console.log('Finding Address');
  //   if (navigator.geolocation) {
  //     let geocoder = new google.maps.Geocoder();
  //     let latlng = new google.maps.LatLng(this.lat, this.lng);
  //     let request = { latLng: latlng };
  //     geocoder.geocode(request, (results, status) => {
  //       if (status === google.maps.GeocoderStatus.OK) {
  //         let result = results[0];
  //         this.markers.push(results[0].geometry.location);
  //         let rsltAdrComponent = result.address_components;
  //         let resultLength = rsltAdrComponent.length;
  //         if (result != null) {
  //           this.address_level_1  = rsltAdrComponent[resultLength - 8].long_name;
  //           console.log("block"+ this.address_level_1 )
  //         } 
  //         if (result != null) {
  //           this.address_level_1  = rsltAdrComponent[resultLength - 7].long_name;
  //           console.log("addr1"+ this.address_level_1 )
  //         } 
  //         if (result != null) {
  //           this.address_level_2 = rsltAdrComponent[resultLength - 6].long_name;
  //           console.log("addr2"+ this.address_level_2)
  //         } 
        
  //         if (result != null) {
  //           this.address_state = rsltAdrComponent[resultLength - 5].long_name;
  //           console.log("state"+ this.address_state)
  //         } 
  //         if (result != null) {
  //           this.address_country = rsltAdrComponent[resultLength - 2].long_name;
  //           console.log("country"+ this.address_country)
  //         } 
  //         if (result != null) {
  //           this.address_zip  = rsltAdrComponent[resultLength - 1].long_name;
  //           console.log("zip"+ this.address_zip )
  //         } 
  //         // for (var i = 0; i < results[0].address_components.length; i++) {
  //         //   let types = results[0].address_components[i].types
  //         //   console.log(types);
  //         //   if (types.indexOf('locality') != -1) {
  //         //     this.address_level_2 = results[0].address_components[i].long_name
  //         //   }
  //         //   if (types.indexOf('country') != -1) {
  //         //     this.address_country = results[0].address_components[i].long_name
  //         //   }
  //         //   if (types.indexOf('postal_code') != -1) {
  //         //     this.address_zip = results[0].address_components[i].long_name
  //         //   }
  //         //   if (types.indexOf('administrative_area_level_1') != -1) {
  //         //     this.address_state = results[0].address_components[i].long_name
  //         //   }
          
         
  //       }
  //       else {
  //         alert('No address available!');
  //       }
  //     });
  // }
  // }
   GetAddress() {
  //   let latitude;
  //   let longitude;
  //   //var lat = parseFloat(document.getElementById("txtLatitude").value);
  //  // var lng = parseFloat(document.getElementById("txtLongitude").value);
  //  for(var i=0; i< this.markers.length; i++){
  //   // alert("dsfvds"+this.markers.length)
  //    for(let item of this.markers){
  //     latitude = item.lat;
  //      longitude = item.lng;
  //     // alert("enterd"+latitude+longitude);
     
  //  }
    var latlng = new google.maps.LatLng(this.lat, this.lng);
    console.log("jsdgj"+JSON.stringify(this.markers));
    var geocoder = geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'latLng': latlng }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            if (results[1]) {
                alert("Location: " + results[1].formatted_address);
            }
        }
    });
 // }
}
  // findLocation(address) {
  //   if (!this.geocoder) this.geocoder = new google.maps.Geocoder()
  //   this.geocoder.geocode({
  //     'address': address
  //   }, (results, status) => {
  //     console.log(results);
  //     if (status == google.maps.GeocoderStatus.OK) {
  //       for(var z=0; z<this.markers.length; z++){
  //       for (var i = 0; i < results[z].address_components.length; i++) {
  //         let types = results[0].address_components[i].types
  //         console.log(types);
  //         if (types.indexOf('locality') != -1) {
  //           this.address_level_2 = results[z].address_components[i].long_name
  //         }
  //         if (types.indexOf('country') != -1) {
  //           this.address_country = results[z].address_components[i].long_name
  //         }
  //         if (types.indexOf('postal_code') != -1) {
  //           this.address_zip = results[z].address_components[i].long_name
  //         }
  //         if (types.indexOf('administrative_area_level_1') != -1) {
  //           this.address_state = results[z].address_components[i].long_name
  //         }
  //       }
  //     }
  //       if (results[0].geometry.location) {
  //         this.lat = results[0].geometry.location.lat();
  //         this.lng = results[0].geometry.location.lng();
  //         this.markers.lat = results[z].geometry.location.lat();
  //         this.markers.lng = results[z].geometry.location.lng();
  //         this.markers.draggable = false;
  //        // this.location.viewport = results[0].geometry.viewport;
  //       }

  //       this.map.triggerResize()
  //     } 
  //     else {
  //       alert("Sorry, this search produced no results.");
  //     }
  //   });
  
  // }
  findAddressByCoordinates() {
   

    this.geocoder.geocode({
      // 'location': 
      //   this.markers.push({
      //     lat: this.markers[0].lat,
      //     lng: this.markers[0].lng,
      //     draggable: true
      //   }),
      'location':{
      lat: this.markers[0].lat,
        lng: this.markers[0].lng,
       
      }
    }, (results, status) => {
      this.decomposeAddressComponents(results);
    })
  }

  decomposeAddressComponents(addressArray) {
    if (addressArray.length == undefined) return false;
    var address = addressArray[0].address_components;
    console.log(address);
    for(let element of address) {
      console.log(element);
      if (element.length == 0 && !element['types']) continue
      if (element['types'].indexOf('street_number') > -1) {
        this.address_level_1 = element['long_name'];
        continue;
      }
      if (element['types'].indexOf('route') > -1) {
        this.address_level_1 += ', ' + element['long_name'];
        continue;
      }
      if (element['types'].indexOf('locality') > -1) {
        this.address_level_2 = element['long_name'];
        continue;
      }
      if (element['types'].indexOf('administrative_area_level_1') > -1) {
        this.address_state = element['long_name'];
        continue;
      }
      if (element['types'].indexOf('country') > -1) {
        this.address_country = element['long_name'];
        continue;
      }
      if (element['types'].indexOf('postal_code') > -1) {
        this.address_zip = element['long_name'];
        continue;
      }
  
    }
  }
  clickedMarker(infowindow) {
    if (this.previous) {
        this.previous.close();
    }
    this.previous = infowindow;
    this.findAddressByCoordinates();
  // this.updateOnMap();
   this.GetAddress();
    
  // this.graphAddress();
 }
  updateOnMap() {
    console.log('updating')
    let full_address: string = this.address_level_1 || ""
    if (this.address_level_2) full_address = full_address + " " + this.address_level_2
    if (this.address_state) full_address = full_address + " " + this.address_state
    if (this.address_country) full_address = full_address + " " + this.address_country
    //this.findLocation(full_address);
    console.log(full_address);
  }

  circleRadiusInKm() {
    return this.circleRadius / 1000;
  }

  milesToRadius(value) {
    this.circleRadius = value / 0.00062137;
  }

  circleRadiusInMiles() {
    return this.circleRadius * 0.00062137;
  }
 mapClicked($event: AGMMouseEvent) {
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true
    });
    console.log($event.coords.lat);
    console.log($event.coords.lng);
  }
  // clickedMarker(label: string, index: number) {
  //   console.log(`clicked the marker: ${label || index}`)
  //   this.findAddressByCoordinates();

  // }
  markerDragEnd(m: any, $event: any) {
    // this.markers.push({
    //   lat: m.coords.lat,
    //   lng: m.coords.lng,
    //  // place: $event.coords.place,
    //   draggable: true
    // });
  //  updateMarkerStatus('Drag ended');
   // geocodePosition(m.getPosition());
    this.markers.lat = m.coords.lat;
    
    console.log("jhsgdjgsd"+this.markers.lat)
    this.markers.lng = m.coords.lng;
    console.log("jhsgdjgsd"+this.markers.lng)
    //this.findAddressByCoordinates();
   // this.geocodePosition(this.markers.getPosition());
  }
  graphAddress(){
    var address;
    this.geocoder.geocode({'latLng': address.getPosition()}, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                    if (results[0]) {
                            var address = results[0].formatted_address.split(",");
                            var country = address[address.length -1];       
                            var cityname = address[address.length -3];                      
                            var state_zipcode = address[address.length -2].split(" ");
                            var state   = state_zipcode[1];
                            var zipcode = state_zipcode[2];
                            address = address.splice(0,(address.length -3));
                      }
                }
        });
}

geocodeLatLng(geocoder, lat, lng, infowindow) {
 //var input = document.getElementById('latlng').value;
 // var latlngStr = input.split(',', 2);
  var latlng = {lat: parseFloat(this.markers.latitude), lng: parseFloat(this.markers.longitude)};
  geocoder.geocode({'location': latlng}, function(results, status) {
    if (status === 'OK') {
      if (results[0]) {
        this.markers.push({
             lat:this.markers.lat,
             lng:this.markers.lng,
             draggable: true
           });
       
      } else {
        window.alert('No results found');
      }
    } else {
      window.alert('Geocoder failed due to: ' + status);
    }
  });
} 

}

// interface Marker {
//   lat: number;
//   lng: number;
//   label?: string;
//   draggable: boolean;
// }

interface Location {
  lat: number;
  lng: number;
  viewport?: Object;
  zoom: number;
  address_level_1?: string;
  address_level_2?: string;
  address_country?: string;
  address_zip?: string;
  address_state?: string;
  //marker?: Marker;
}



// WEBPACK FOOTER //
// ./src/app/mapstest/mapstest.component.ts